import { Component, OnInit, signal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CardModule } from 'primeng/card';
import { Router } from '@angular/router';
import { McSearchSettingsService } from 'src/app/api/caching/mc-search-settings.service';
import { McSettingsService } from 'src/app/api/mc-settings.service';
import { DefaultLeadSearch } from 'src/app/api/types/recruiting';

interface SavedLeadSearch {
  searchName: string;
  default: boolean;
  id: string;
}

@Component({
  selector: 'app-my-saved-lead-searches',
  templateUrl: './my-saved-lead-searches.component.html',
  styleUrls: ['./my-saved-lead-searches.component.scss'],
  standalone: true,
  imports: [CommonModule, CardModule]
})
export class MySavedLeadSearchesComponent implements OnInit {
  savedSearches = signal<SavedLeadSearch[]>([]);
  loading = signal<boolean>(true);
  error = signal<string | null>(null);
  defaultLeadSearch = signal<DefaultLeadSearch>({uuid: ''});

  constructor(
    private mcSearchSettingsService: McSearchSettingsService,
    private mcSettingsService: McSettingsService,
    private router: Router
  ) {}

  ngOnInit() {
    // Load all data in sequence to ensure default lead search is available when mapping
    this.mcSettingsService.getMyDefaultLeadSearch().subscribe({
      next: (defaultLeadSearch) => {
        this.defaultLeadSearch.set(defaultLeadSearch);
        this.loadSavedSearches();
      },
      error: (error) => {
        console.error('Error loading default lead search:', error);
        this.loadSavedSearches();
      }
    });
  }

  private loadSavedSearches(): void {
    // Load saved searches independently to avoid forkJoin blocking
    let leadSearchSettingsLoaded = false;
    let leadSearchesLoaded = false;
    let leadSearchSettings: any[] = [];
    let leadSearches: any[] = [];

    const updateSearches = () => {
      if (leadSearchSettingsLoaded && leadSearchesLoaded) {
        const allSearches = [...leadSearchSettings, ...leadSearches];
        
        const mappedSearches = allSearches.map(search => ({
          searchName: search.name ?? '',
          default: search.uuid === this.defaultLeadSearch().uuid,
          id: search.uuid
        }));
        
        this.savedSearches.set(mappedSearches);
        this.loading.set(false);
      }
    };

    // Load leadSearchSetting type
    this.mcSearchSettingsService.getSearchSettingsByType('leadSearchSetting').subscribe({
      next: (settings) => {
        leadSearchSettings = settings;
        leadSearchSettingsLoaded = true;
        updateSearches();
      },
      error: (error) => {
        console.error('Error loading leadSearchSetting:', error);
        leadSearchSettings = [];
        leadSearchSettingsLoaded = true;
        updateSearches();
      }
    });

    // Load leadSearch type
    this.mcSearchSettingsService.getSearchSettingsByType('leadSearch').subscribe({
      next: (searches) => {
        leadSearches = searches;
        leadSearchesLoaded = true;
        updateSearches();
      },
      error: (error) => {
        console.error('Error loading leadSearch:', error);
        leadSearches = [];
        leadSearchesLoaded = true;
        updateSearches();
      }
    });
  }

  onSearchClick(search: SavedLeadSearch): void {
    // Navigate to lead-search page with the search UUID as a query parameter
    this.router.navigate(['/recruiting/lead-search'], {
      queryParams: { searchId: search.id }
    });
  }
} 
